import { gql } from 'graphql-request';

// TODO: Add new fields priceChangeLastClose priceChangePctLastClose
export const FRAGMENT_TRANSACTION_HISTORY_EVENT_HISTORY_SALE = gql`
  fragment TransactionHistoryEventSale on ComplexFieldsSaleEventHistory {
    addressId
    armsLength
    date
    daysOnMarketCumulative
    distressed
    entityId
    hcMlsId
    listingId
    listingGroupId
    price
    priceChangeLastClose
    priceChangePctLastClose
    priceVariance
    reo
    sourceId
    sourceType
    status
  }
`;

export const FRAGMENT_TRANSACTION_HISTORY_EVENT_HISTORY_RENTAL = gql`
  fragment TransactionHistoryEventRental on ComplexFieldsRentalEventHistory {
    addressId
    armsLength
    date
    daysOnMarketCumulative
    distressed
    entityId
    hcMlsId
    listingId
    listingGroupId
    price
    priceChangeLastClose
    priceChangePctLastClose
    priceVariance
    reo
    sourceId
    sourceType
    status
  }
`;
